import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {SearchQuery} query
     * @returns {Promise<void>}
     */
    async searchProductStatuses (query) {
        try {
            const response = await http.get('/products/inventory/statuses', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
